import { RobotOutlined } from '@ant-design/icons'
import { Empty } from 'antd'
import { ListPageIntro, ListPageShell } from '../../common'

export const AgentsProjectManager = () => {
	return (
		<ListPageShell>
			<ListPageIntro
				icon={RobotOutlined}
				title="Agent: Project Manager"
				subtitle="Manage Project Manager agent settings and prompts."
			/>
			<Empty description="Project Manager agent page is coming soon." />
		</ListPageShell>
	)
}
